<div class="segmented-control" [class.segmented-control--disabled]="disabled">
  <button
    type="button"
    class="segmented-control__option"
    *ngFor="let option of options; trackBy: trackByValue"
    [ngClass]="{
      'segmented-control__option--active': option.value === value,
      'segmented-control__option--disabled': option.disabled
    }"
    (click)="selectOption(option)"
  >
    <span class="segmented-control__label">{{ option.label }}</span>
    <span class="segmented-control__description" *ngIf="option.description">
      {{ option.description }}
    </span>
  </button>
</div>
